// import enum
export const state = {
  filter: {
    action: "",
    display_name: "",
    status: [],
    isFilter: false,
  },
};
export const mutations = {
  ADD_FILTER_PERMISSION: (state, data) => {
    state.filter = data;
    state.filter.isFilter = true;
  },
  CLEAR_FILTER_PERMISSION: (state) => {
    state.filter = {
      action: "",
      display_name: "",
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_PERMISSION: (state) => {
    return state.filter;
  },
};
export const actions = {
  ADD_FILTER_PERMISSION: ({ commit }, data) => {
    commit("ADD_FILTER_PERMISSION", data);
  },
  CLEAR_FILTER_PERMISSION: ({ commit }) => {
    commit("CLEAR_FILTER_PERMISSION");
  },
};
